"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledText = void 0;
var _Text = require("./Text");
// TODO: in v9, move styled() from Text.jsx to here
var StyledText = _Text.Text;
exports.StyledText = StyledText;